/** @format */

import {styled} from '@mui/material/styles';
import {TextField} from '@mui/material';

interface StyledTextFieldProps {
  compact?: boolean;
}

export const StyledTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== 'compact',
})<StyledTextFieldProps>(({theme, compact}) => ({
  width: '100%',
  minHeight: compact ? 'unset' : '48px',

  '.MuiInputBase-root input': {
    minHeight: compact ? 'unset' : '48px',
    padding: compact ? 0 : theme.spacing(0, 4),
  },

  '.MuiInputBase-root textarea': {
    padding: 0,
  },
}));
